export const GET_AVAILABLE_UNITS_REQUEST = "AVAILABLE_UNITS/GET_AVAILABLE_UNITS_REQUEST";
export const GET_AVAILABLE_UNITS_SUCCESS = "AVAILABLE_UNITS/GET_AVAILABLE_UNITS_SUCCESS";
export const GET_AVAILABLE_UNITS_FAILURE = "AVAILABLE_UNITS/GET_AVAILABLE_UNITS_FAILURE";

export const ADD_AVAILABLE_UNITS_REQUEST = "AVAILABLE_UNITS/ADD_AVAILABLE_UNITS_REQUEST";
export const ADD_AVAILABLE_UNITS_SUCCESS = "AVAILABLE_UNITS/ADD_AVAILABLE_UNITS_SUCCESS";
export const ADD_AVAILABLE_UNITS_FAILURE = "AVAILABLE_UNITS/ADD_AVAILABLE_UNITS_FAILURE";

export const EDIT_AVAILABLE_UNITS_REQUEST = "AVAILABLE_UNITS/EDIT_AVAILABLE_UNITS_REQUEST";
export const EDIT_AVAILABLE_UNITS_SUCCESS = "AVAILABLE_UNITS/EDIT_AVAILABLE_UNITS_SUCCESS";
export const EDIT_AVAILABLE_UNITS_FAILURE = "AVAILABLE_UNITS/EDIT_AVAILABLE_UNITS_FAILURE";

export const REMOVE_AVAILABLE_UNITS_REQUEST = "AVAILABLE_UNITS/REMOVE_AVAILABLE_UNITS_REQUEST";
export const REMOVE_AVAILABLE_UNITS_SUCCESS = "AVAILABLE_UNITS/REMOVE_AVAILABLE_UNITS_SUCCESS";
export const REMOVE_AVAILABLE_UNITS_FAILURE = "AVAILABLE_UNITS/REMOVE_AVAILABLE_UNITS_FAILURE";

export const GET_AVAILABLE_UNITS_LIST_REQUEST = "AVAILABLE_UNITS/GET_AVAILABLE_UNITS_LIST_REQUEST";
export const GET_AVAILABLE_UNITS_LIST_SUCCESS = "AVAILABLE_UNITS/GET_AVAILABLE_UNITS_LIST_SUCCESS";
export const GET_AVAILABLE_UNITS_LIST_FAILURE = "AVAILABLE_UNITS/GET_AVAILABLE_UNITS_LIST_FAILURE";



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AvailableUnits/constants.js